<template>
  <div class="assign-team" v-loading="loading">
    <div v-for="item in showData" :key="item.teamId" @click="setSelect(item)">
      <div class="item" :class="{selected: selected === item.teamId}">
        <div class="box"></div>
        <div class="driver">
          <div class="left">
            <fl-avatar :src="item.primaryAvatar" :size="20" class="avatar" :nickname="item.primaryDriverName"></fl-avatar>
            <div class="name">{{ item.primaryDriverName }}</div>
          </div>
          <div class="right">Primary Driver</div>
        </div>
        <div class="driver">
          <div class="left">
            <fl-avatar :src="item.secondlyAvatar" :size="20" class="avatar" :nickname="item.secondlyDriverName"></fl-avatar>
            <div class="name">{{item.secondlyDriverName}}</div>
          </div>
          <div class="right">Secondary Driver</div>
        </div>
      </div>
      <div class="split"></div>
    </div>
  </div>
</template>

<script>
import {driverListForAssign} from "@/api/driver";
import { mapState } from 'vuex'
export default {
  name: "assign-team",
  props: {
    selectedCallBack: Function,
    teamKeyWord: String,
  },
  data() {
    return {
      selected: 1,
      showData: [],
      loading: false
    }
  },
  watch: {
    teamKeyWord() {
      this.updateList()
    }
  },
  computed: {
        ...mapState({
            // driverData: (state) => state.dispatch.driverData,
            assginShow: (state) => state.dispatch.assginShow,
        }),
    },
  created() {
    this.updateList()
  },
  methods: {
    setSelect(item) {
      this.selected = item.teamId;
      this.selectedCallBack(item)
    },
    updateList() {
      this.loading = true;
      driverListForAssign(this.teamKeyWord, this.assginShow.value.loadInfo.companyId).then(res => {
        console.log(res,'58result')
        this.showData = res.data
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.assign-team {
  overflow-y: scroll;
  //overflow-x: hidden;
  height: 332px;
  width: 362px;
  .split {
    border-bottom: 1px #E7EBF3 solid;
    width: 411px;
    margin-left: 4px;
  }
  .item {
    width: 362px;
    margin: 4px 0;
    padding: 16px 16px 8px 42px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;

    &.selected {
      background: #F5F7FA;
      .box {
        border: 5px solid #4066D4;
      }
    }

    .box {
      border: 1px solid #B2B6C0;
      border-radius: 8px;
      box-sizing: border-box;
      position: absolute;
      left: 16px;
      top: 16px;
      width: 16px;
      height: 16px;
    }
    .driver {
      display: flex;
      line-height: 20px;
      margin-bottom: 8px;

      .left {
        flex: 1;
        display: flex;
        .name {
          font-weight: 600;
          font-size: 14px;
          flex: 1;
        }
        .avatar {
          margin-right: 8px;
        }
      }
      .right {
        font-weight: 400;
        font-size: 12px;
        color: #7F8596;
      }
    }
  }

}

</style>
